// Web SyncTransport over BroadcastChannel (002 store rework, STAGE 6).
//
// The MatchStore mirrors its WHOLE state to other windows through this transport: the main
// window broadcasts on every command; secondary windows apply incoming state without echoing
// back (createStore guards via isMain). Messages are wrapped as { __match: state } so this
// channel can coexist with any non-match traffic — non-__match messages are ignored.
//
// Tiny + dependency-free. The channel is injectable for testability but defaults to the
// shared 'scoreboard-sync' BroadcastChannel.

export function createBroadcastTransport(channel = new BroadcastChannel('scoreboard-sync')) {
  return {
    broadcast(state) {
      channel.postMessage({ __match: state });
    },
    onPatch(handler) {
      const listener = (event) => {
        const data = event?.data;
        if (!data || !('__match' in data)) return;
        handler(data.__match);
      };
      channel.addEventListener('message', listener);
      return () => channel.removeEventListener('message', listener);
    },
  };
}
